import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'section[app-home-welcome]',
  imports: [MatIconModule, NgClass],
  templateUrl: './home-welcome.html',
  styleUrl: './home-welcome.scss',
})
export class HomeWelcome {
  @Input() texts: string[] = [
    'LIVE IN STYLE',
    'EVERYDAY FASHION',
    'FEEL THE MOMENT',
    'MADE FOR DAILY BEAUTY',
  ];
  @Input() right: boolean = false;
  get appname() {
    return environment.appname;
  }
}
